import styled from 'styled-components'

import * as LayoutUtils from './utils'
import type { LayoutPanels, BaseContainer, Image } from './utils'
import { txt } from '../../../../../locales/i18n'

export const collageLayoutPanels: LayoutPanels = {
	layoutName: txt('cms.layoutNames.collage'),
	panels: [
		{
			label: txt('cms.panelNames.layout container'),
			formKey: 'container',
			type: 'baseContainerPanel',
		},

		{
			label: txt('cms.panelNames.image') + ' 1',
			formKey: 'image1',
			type: 'imagePanel',
		},

		{
			label: txt('cms.panelNames.image') + ' 2',
			formKey: 'image2',
			type: 'imagePanel',
		},

		{
			label: txt('cms.panelNames.image') + ' 3',
			formKey: 'image3',
			type: 'imagePanel',
		},
	],
}

type CollageLayoutProps = {
	container: BaseContainer
	image1: Image
	image2: Image
	image3: Image
}

export const collageLayoutValues: CollageLayoutProps = {
	container: LayoutUtils.defaultBaseContainer,
	image1: {
		alt: 'lorem',
		source: 'oplevalt.jpg',
		link: '',
		text: '',
		textColor: '#000000',
		fit: 'cover',
		shadow: true,
		animation: LayoutUtils.defaultAnimation,
	},

	image2: {
		alt: 'lorem',
		source: 'oplevalt.jpg',
		link: '',
		text: '',
		textColor: '#000000',
		fit: 'cover',
		shadow: true,
		animation: LayoutUtils.defaultAnimation,
	},

	image3: {
		alt: 'lorem',
		source: 'oplevalt.jpg',
		link: '',
		text: '',
		textColor: '#000000',
		fit: 'cover',
		shadow: true,
		animation: LayoutUtils.defaultAnimation,
	},
}

const ImageWrapper = (props: CollageLayoutProps['image1']) => {
	const imageClassNames = ['image-wrapper']
	if (props.shadow !== false) imageClassNames.push('box-shadow')

	const renderContent = () => (
		<>
			<div className={imageClassNames.join(' ')}>
				<img
					alt={props.alt}
					style={{ objectFit: props.fit }}
					src={LayoutUtils.getImageSource(props.source)}
					{...LayoutUtils.getAnimationProps(props.animation)}
				/>
			</div>

			{props.text && (
				<h3 className="text-container" style={{ color: props?.textColor }}>
					{props.text}
				</h3>
			)}
		</>
	)

	if (props.link) {
		return (
			<a className="image-container" href={props.link} onClick={(event) => event.preventDefault()}>
				{renderContent()}
			</a>
		)
	}

	return <div className="image-container">{renderContent()}</div>
}

export const CollageLayout = (props: CollageLayoutProps) => (
	<CollageLayoutPreviewStyled styledProps={props} {...LayoutUtils.getAnimationProps(props.container.animation)}>
		<ImageWrapper {...props.image1} />
		<ImageWrapper {...props.image2} />
		<ImageWrapper {...props.image3} />
	</CollageLayoutPreviewStyled>
)

const CollageLayoutPreviewStyled = styled.div<{ styledProps: CollageLayoutProps }>`
	display: flex;
	gap: 1ch;
	overflow: hidden;
	justify-content: center;

	background-repeat: no-repeat;
	background-color: ${({ styledProps }) => styledProps.container.backgroundColor};
	background-size: ${({ styledProps }) => styledProps?.container?.coverFit ?? 'cover'};
	background-position: ${({ styledProps }) => styledProps?.container?.coverPosition ?? 'center'};
	background-image: ${({ styledProps }) => {
		if (styledProps.container.coverSource === '') return 'none'
		return `url(${LayoutUtils.getImageSource(styledProps.container.coverSource)})`
	}};

	min-height: ${({ styledProps }) => (styledProps.container.fullscreen ? '100dvh' : 'auto')};

	.image-container {
		position: relative;
		width: calc(100% / 3);
		max-width: ${({ styledProps: { container } }) => (container.fullscreen ? 'auto' : '325px')};
		margin: 2rem;

		.image-wrapper {
			overflow: hidden;
			border-radius: 0.65rem;
			aspect-ratio: 3 / 4;
		}

		img {
			object-fit: cover;
			height: 100%;
			width: 100%;
		}

		.box-shadow {
			box-shadow: 0 0 1rem #6669;
		}

		.text-container {
			margin-top: 1rem;
			text-align: center;
		}
	}
`
